var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"statusCell flex-row flex-align-center"},[_c('div',{class:['state-icon', _vm.statusData.style]}),_c('span',{staticClass:"ml-4"},[_vm._v(_vm._s(_vm.statusData.label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }